import { FieldTypes } from '../constants'
import {
  BooleanField,
  DropdownField,
  EmailField,
  FieldMap,
  InputFormElement,
  PhoneField,
  TextField,
} from '../types'
import { addCondition } from './utils'

export const hasPartnerField: BooleanField = {
  type: FieldTypes.BOOLEAN,
  placeholder: 'Patient has Partner',
  labels: [{ text: 'Do you have a partner?' }],
}

export const partnerNameField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: "Partner's Name",
}
export const partnerEmailField: EmailField = {
  optional: true,
  type: FieldTypes.EMAIL,
  placeholder: "Partner's Email",
  row: {
    index: 0,
    flex: 1,
  },
}
export const partnerPhoneField: PhoneField = {
  type: FieldTypes.PHONE,
  placeholder: "Partner's Phone",
  optional: true,
  row: {
    index: 0,
    flex: 1,
  },
}

export const okToContactField: BooleanField = {
  type: FieldTypes.BOOLEAN,
  placeholder: 'OK to Contact Partner',
  labels: [{ text: 'Is it OK to contact your partner?' }],
  row: {
    index: 1,
    flex: 1,
  },
}

export const partnerContactMethodField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'How should we contact your partner?',
  options: [
    { text: 'Email', id: 'email' },
    { text: 'Text', id: 'text' },
  ],
  condition: v => !!v?.okToContact,
  row: {
    index: 1,
    flex: 1,
  },
}
export const partnerContactField: FieldMap = {
  condition: v => v?.hasPartner,
  name: 'Partner Contact',
  children: {
    name: partnerNameField,
    phone: partnerPhoneField,
    email: partnerEmailField,
    okToContact: okToContactField,
    contactMethod: partnerContactMethodField,
  },
}

const addHasPartnerCondition = (field: InputFormElement) =>
  addCondition(field, v => !!v?.hasPartner)

export const gynPartnerContactField: FieldMap = {
  name: 'Partner Contact',
  children: {
    hasPartner: hasPartnerField,
    name: addHasPartnerCondition(partnerNameField),
    phone: addHasPartnerCondition(partnerPhoneField),
    email: addHasPartnerCondition(partnerEmailField),
    okToContact: addHasPartnerCondition(okToContactField),
    contactMethod: addHasPartnerCondition(partnerContactMethodField),
  },
}
